























































































import axios from 'axios'
import { Component } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import User, { IUser } from '@/models/User'
import BasicForm from '@/components/entry/BasicForm.vue'
import ChangeJobForm from '@/components/entry/ChangeJobForm.vue'
import FormBase from '@/pages/form-base'
import EntryLayout from '@/components/entry/Layout.vue'
import {apiV1UsersCurrentPath, apiV1UsersPath} from '@/rails/routes'

@Component({
  components: {
    EntryLayout,
    BasicForm,
    ChangeJobForm
  }
})
export default class MyPageIndex extends VueBase {
  userForBasic = new User()
  userForChangeJob = new User()
  step = 1
  agree = this.settings.entry.agent_service
  selectedTab = Number(new URLSearchParams(window.location.search).get('selectedTab')) || 0
  errors = {}
  // GA対応のため、登録完了画面からrenderされた場合はチュートリアル。
  tutorial = window.location.pathname.includes('users/complete')

  async mounted(): Promise<void> {
    this.showLoading()
    try {
      const res = await axios.get<IUser>(apiV1UsersCurrentPath())
      this.userForBasic = new User(res.data)
      this.userForChangeJob = new User(res.data)
    } catch (e) {
      window.location.href = '/users/sign_in'
    }
    this.hideLoading()
  }

  async finishTutorial(): Promise<void> {
    await this.saveAgentService()
    window.location.href = '/mypage?selectedTab=1'
  }

  async saveBasic(): Promise<void> {
    if (!(this.$refs.basicForm as FormBase).validate()) {
      this.showError('入力内容に不備があります。確認してください。')
      return
    }

    try {
      await axios.put(apiV1UsersPath(), {
        user: this.userForBasic.toParams()
      })
      this.errors = {}
      this.showMessage('基本情報の変更が完了しました')
    } catch (e) {
      this.showError('入力内容に不備があります。確認してください。')
      this.errors = JSON.parse(e.request.response)
    }
  }

  async saveAgentService(): Promise<void> {
    try {
      await axios.put(apiV1UsersPath(), {
        user: { agent_service: true }
      })
    } catch (e) {
      this.showError('入力内容に不備があります。確認してください。')
    }
  }

  async saveChangeJob(): Promise<void> {
    if (!(this.$refs.changeJobForm as FormBase).validate()) {
      this.showError('入力内容に不備があります。確認してください。')
      return
    }

    try {
      await axios.put(apiV1UsersPath(), {
        user: this.userForChangeJob.toParams()
      })
      this.errors = {}
      this.showMessage('転職に関する情報の変更が完了しました')
    } catch (e) {
      this.showError('入力内容に不備があります。確認してください。')
      this.errors = JSON.parse(e.request.response)
    }
  }

  showRecruit(): void {
    window.open(this.settings.site.recruit, '_blank')
    window.location.href = '/mypage'
  }

  showTop(): void {
    window.open(this.settings.site.top, '_blank')
    window.location.href = '/mypage'
  }
}
